import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BodyClassManager = () => {
  const location = useLocation();

  useEffect(() => {
    const pageClass = getBodyClassForRoute(location.pathname);
    if (pageClass) {
      document.body.classList.add(pageClass);
    }

    return () => {
      if (pageClass) {
        document.body.classList.remove(pageClass);
      }
    };
  }, [location.pathname]);

  return null; // This component does not render anything
};

// Helper function to map routes to classes
const getBodyClassForRoute = (pathname: string) => {
  const routeClasses: Record<string, string> = {
    "/": "nav-elements-white", 
    "/home": "nav-elements-white",
    "/dashboard": "nav-elements-dashboard",
  };

  return routeClasses[pathname] || "";
};

export default BodyClassManager;
